<div *ngIf="loading" class="card">
  <div class="image-wrapper div-position margin-b">
    <img class="card-img-top" src="{{ renderImage(props.coverPhoto) }}" alt="" (error)="getErrorImage($event)" />
  </div>
  <div class="card-body margin-b">
    <div class="display justify-content profile-header">
      <div class="display profile-identity">
        <div class="inner-box">
          <button class="btn btn-sm edit-profile" (click)="editProfile()">Edit Profile</button>
          <div class="image-wrapper margin-b">
            <img class="profile" style="border-radius: 50%; height: 100px; width: 100px"
              [src]="renderImage(props.photo)" alt="" (error)="getErrorImage($event)" />
          </div>
        </div>
        <div class="profile-stats">
          <div class="display margin-l-l title-font">
            <div class="cursor" (click)="navigate()">Our Network</div>
            <div class="margin-l">{{ props?.followersCount }}</div>
          </div>

          <div class="display margin-l-l title-font">
            <div>Visitors</div>
            <div class="margin-l">{{ props?.visitorsCount }}</div>
          </div>
        </div>
      </div>

      
      <div *ngIf="type == 'profile'" class="profile-app-links">
        <div class="display profile-social-icons">
          <div class="cursor">
            <!-- <img src="assets/pie-chart.png" style="height: 40px" /> -->
            <!-- <img  style="height: 40px" [src]="renderImage(props.photo)" alt="cover" class="img-fluid cover-image image"> -->
          </div>
          <div class="margin-l-l cursor">
            <img src="assets/social.png" style="height: 40px" />
          </div>
        </div>
        <div class="display profile-app-store-icons">
          <div class="title-font" style="color: #176663; margin: 5px auto; font-size: 18px">
            Open App
          </div>
        </div>

        <div class="display">
          <div class="cursor">
            <a href="https://play.google.com/store" target="_blank">
              <img src="assets/googlePlay.jpg" style="height: 40px" /></a>
          </div>
          <div class="margin-l-l cursor">
            <a href="https://www.apple.com/app-store/" target="_blank">
              <img src="assets/appleC-1.png" style="height: 40px" /></a>
          </div>
        </div>
      </div>

      <div style="text-align: end" *ngIf="type != 'profile'">
        <button class="btn main-backgroundcolor color" (click)="follow()">
          {{ text }}
        </button>
        <button class="btn main-backgroundcolor color margin-l" (click)="managePartner(secondText)">
          {{ secondText }}
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="card-body">
    <div class="display border-b" style="margin-bottom: 20px">
      <div><img src="assets/icon-1.jpg" style="height: 22px" /></div>
      <div class="margin-l border-b">
        <p class="margin-b title-font">{{ props?.name }}</p>
      </div>
    </div>

    <div class="display border-b" style="margin-bottom: 20px">
      <div><img src="assets/org.png" style="height: 20px" /></div>
      <div class="margin-l" style="width: -webkit-fill-available;">
        <p class="margin-b title-font">
          {{ props?.logLine ? props?.logLine : "--" }}
        </p>
      </div>
    </div>
    <!-- <div class="display border-b" style="margin-bottom: 20px">
      <div><img src="assets/images/hands.png" style="height: 20px" /></div>
      <div class="margin-l">
        <p class="margin-b title-font">
          {{
          props?.fellowshipPrimaryFunction
          ? props?.fellowshipPrimaryFunction: "--" || props?.profitType.name ?props?.profitType.name:'--'

          }}
        </p>
      </div>
    </div> -->

    <div class="border-b margin-b">
      <h5 class="card-title font-weight">Introduction</h5>
      <p class="margin-b">
        {{
        !props?.introduction ? "--" : (props?.introduction | titlecase)
        }}
      </p>
    </div>

    <div class="border-b margin-b">
      <h5 class="card-title font-weight">General Info</h5>
      <p class="margin-b">
        {{ !props?.generalInfo ? "--" : (props.generalInfo | titlecase) }}
      </p>
    </div>

    <div class="border-b margin-b">
      <h6 class="card-title font-weight" style="text-align: justify; color: #176663">
        <!-- {{
        props.customCategory.length != 0
        ? props.customCategory[0].title
        : "--"
        }} -->
        Mission Statement
      </h6>
      <p class="margin-b">
        <!-- {{
        props.customCategory.length != 0
        ? props.customCategory[0].description
        : "--"
        }} -->

        {{ !props?.missionStateMent ? "--" : (props.missionStateMent | titlecase) }}
      </p>
    </div>

    <div class="border-b margin-b">
      <h5 class="card-title font-weight">Faith</h5>
      <div class="faith-badges">
        <span class="pill">
          {{ props?.faith?.name || '--' }}
        </span>
        <ng-container *ngIf="props?.faithBranch?.name">
          <span class="muted-sep">/</span>
          <span class="pill">
            {{ props.faithBranch.name }}
          </span>
        </ng-container>
        <ng-container *ngIf="props?.faithDenomination?.name">
          <span class="muted-sep">/</span>
          <span class="pill">
            {{ props.faithDenomination.name }}
          </span>
        </ng-container>
      </div>
    </div>

    <div class="border-b margin-b">
      <h5 class="card-title font-weight">Contact & Addresses</h5>
      <ul class="list-unstyled contact-list">
        <li class="display contact-item">
          <i class="fas fa-map-marker-alt font-size contact-icon"></i>
          <div class="margin-l-l contact-content">
            <div class="contact-section-label small">Primary Address</div>
            <a
              class="cursor contact-link"
              href="https://www.google.com/maps/search/?api=1&query={{ props?.address?.googleAddress || props?.address?.address }}"
              target="_blank"
            >
              <p class="margin-b address-text">
                {{ props?.address?.address || props?.address?.streetAddress || '--' }}
              </p>
            </a>
          </div>
        </li>
        <li class="display contact-item" *ngIf="props?.secondaryAddress?.address || props?.secondaryAddress?.streetAddress">
          <i class="fas fa-map-marker-alt font-size contact-icon"></i>
          <div class="margin-l-l contact-content">
            <div class="contact-section-label small">Secondary Address</div>
            <a
              class="cursor contact-link"
              href="https://www.google.com/maps/search/?api=1&query={{ props?.secondaryAddress?.googleAddress || props?.secondaryAddress?.address || props?.secondaryAddress?.streetAddress }}"
              target="_blank"
            >
              <p class="margin-b address-text">
                {{ props?.secondaryAddress?.address || props?.secondaryAddress?.streetAddress || '--' }}
              </p>
            </a>
          </div>
        </li>
        <li class="display contact-item">
          <i class="fas fa-phone-alt font-size contact-icon" style="transform: none !important;"></i>
          <div class="margin-l-l contact-content">
            <div class="contact-section-label small">Phone</div>
            <p class="margin-b address-text">{{ props?.contactNo ? props?.contactNo : '--' }}</p>
          </div>
        </li>
        <li class="display contact-item">
          <i class="fas fa-phone-alt font-size contact-icon" style="transform: none !important;"></i>
          <div class="margin-l-l contact-content">
            <div class="contact-section-label small">
              <b>Alternate Number</b></div>
            <p class="margin-b address-text">{{ props?.AlternateContactNO ? props?.AlternateContactNO : '--' }}</p>
          </div>
        </li>
        <li class="display contact-item">
          <i class="fas fa-envelope font-size contact-icon"></i>
          <div class="margin-l-l contact-content">
            <div class="contact-section-label small">Public Email</div>
            <p class="margin-b address-text"><a class="contact-link" *ngIf="props?.publicEmail" [href]="'mailto:' + props.publicEmail">{{ props.publicEmail }}</a><span *ngIf="!props?.publicEmail">--</span></p>
          </div>
        </li>
        <li class="display contact-item">
          <i class="fas fa-envelope font-size contact-icon"></i>
          <div class="margin-l-l contact-content">
            <div class="contact-section-label small">Account Email</div>
            <p class="margin-b address-text"><a class="contact-link" *ngIf="props?.email" [href]="'mailto:' + props.email">{{ props.email }}</a><span *ngIf="!props?.email">--</span></p>
          </div>
        </li>
      </ul>
    </div>

    <!-- Our Staff -->
    <div *ngIf="type == 'profile'" class="border-b margin-b">
      <h5 class="card-title font-weight margin-b partners-title">
        <i class="fas fa-user-friends"></i> Our Staff
      </h5>

      <div class="partners-container" *ngIf="!loadingStaff && staffItems?.length > 0; else staffLoadingTpl">
        <ngx-slick-carousel class="partners-carousel" #slickModal="slick-carousel" [config]="staffSlideConfig">
          <div ngxSlickItem *ngFor="let staff of staffItems" class="partner-slide">
            <div class="partner-card">
              <div class="partner-image-wrapper">
                <img [src]="renderImage(staff.photo)" (error)="getErrorImage($event)" class="partner-image" alt="Staff" />
                <div class="partner-overlay">
                  <i class="fas fa-id-badge"></i>
                </div>
              </div>
              <div class="partner-content">
                <h6 class="partner-name">{{ staff.name || '--' }}</h6>
                <div class="partner-badge" *ngIf="staff.staffTypeName">
                  <i class="fas fa-user-tie"></i>
                  {{ staff.staffTypeName }}
                </div>
                <div class="partner-stats" *ngIf="staff.logLine || staff.email">
                  <span class="stat-item" *ngIf="staff.logLine">
                    <i class="fas fa-briefcase"></i>
                    {{ staff.logLine }}
                  </span>
                  <span class="stat-item" *ngIf="staff.email">
                    <i class="fas fa-envelope"></i>
                    {{ staff.email }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ngx-slick-carousel>

        <div class="display justify-content" style="margin-top:10px">
          <button class="btn btn-sm main-backgroundcolor color" (click)="prevStaffPage()" [disabled]="staffSkip === 0">
            <i class="fas fa-chevron-left"></i> Previous
          </button>
          <div class="margin-l margin-r" style="font-weight:600;">
            {{ (staffSkip / staffLimit) + 1 }} / {{ (staffTotal | pageNumber:staffLimit) }}
          </div>
          <button class="btn btn-sm main-backgroundcolor color" (click)="nextStaffPage()" [disabled]="(staffSkip + staffLimit) >= staffTotal">
            Next <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>

      <ng-template #staffLoadingTpl>
        <div class="display" style="gap:10px">
          <app-skelton></app-skelton>
          <app-skelton></app-skelton>
          <app-skelton></app-skelton>
        </div>
      </ng-template>
    </div>

    <!-- Association cards (supports array) -->
    <div *ngIf="type == 'profile' && props?.associatedBy?.length > 0" class="border-b margin-b">
      <h5 class="card-title font-weight margin-b association-title">
        <i class="fas fa-handshake"></i>Our Association
      </h5>
      <div class="association-container">
        <ngx-slick-carousel class="association-carousel" #slickModal="slick-carousel" [config]="slideConfig"
          (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
          <div ngxSlickItem *ngFor="let assoc of props.associatedBy" class="association-slide">
            <div class="association-card">
              <div class="assoc-status-chip" *ngIf="assoc?.status" [ngClass]="{
                'pending': assoc.status === 'pending',
                'approved': assoc.status === 'approved' || assoc.status === 'accepted',
                'rejected': assoc.status === 'rejected'
              }">
                <i class="fas" [ngClass]="{
                  'fa-hourglass-half': assoc.status === 'pending',
                  'fa-check': assoc.status === 'approved' || assoc.status === 'accepted',
                  'fa-times': assoc.status === 'rejected'
                }"></i>
                {{ assoc.status | titlecase }}
              </div>
              <div class="association-image-wrapper">
                <img [src]="renderImage(assoc?.community?.photo)"
                     (error)="getErrorImage($event)"
                     class="association-image"
                     alt="Association" />
                <div class="association-badge">
                  <i class="fas fa-link"></i>
                </div>
              </div>
              <div class="association-content">
                <h6 class="association-name">{{ assoc?.community?.name }}</h6>
                <div *ngIf="assoc?.community?.email" class="association-email">
                  <i class="fas fa-envelope"></i>
                  {{ assoc?.community?.email }}
                </div>
                <div class="association-status">
                  <span class="status-badge">
                    <i class="fas fa-check-circle"></i>
                   {{assoc.role === 'Satellite' ? "Connected Ministry" :"Headquarters "}} 
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ngx-slick-carousel>
      </div>
    </div>

    

    <!-- Partners: show only when present -->
    <div *ngIf="type == 'profile' && props?.partners?.length > 0" class="border-b margin-b">
      <h5 class="card-title font-weight margin-b partners-title">
        <i class="fas fa-handshake"></i> Our Partners
      </h5>

      <div class="partners-container">
        <ngx-slick-carousel class="partners-carousel" #slickModal="slick-carousel" [config]="slideConfig"
          (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
          <div ngxSlickItem *ngFor="let innerProps of props.partners" class="partner-slide">
            <div class="partner-card">
              <div class="partner-image-wrapper">
                <img [src]="renderImage(innerProps.photo)" (error)="getErrorImage($event)" class="partner-image" alt="Partner" />
                <div class="partner-overlay">
                  <i class="fas fa-external-link-alt"></i>
                </div>
              </div>
              <div class="partner-content">
                <h6 class="partner-name">{{ innerProps.name }}</h6>
                <div class="partner-stats">
                  <span class="stat-item">
                    <i class="fas fa-users"></i>
                    {{ innerProps.followersCount || 0 }}
                  </span>
                  <span class="stat-item">
                    <i class="fas fa-eye"></i>
                    {{ innerProps.visitorsCount || 0 }}
                  </span>
                </div>
                <div class="partner-badge">
                  <i class="fas fa-star"></i>
                  Partner
                </div>
              </div>
            </div>
          </div>
        </ngx-slick-carousel>
      </div>
    </div>
  </div>

</div>

<div *ngIf="!loading" class="card">
  <div class="image-wrapper div-position margin-b">
    <img class="card-img-top" alt="" (error)="getErrorImage($event)" />
  </div>
  <div class="card-body margin-b">
    <div class="display justify-content">
      <div class="display">
        <div class="inner-box">
          <div class="image-wrapper margin-b">
            <img class="profile" style="border-radius: 50%; height: 100px; width: 100px" alt=""
              (error)="getErrorImage($event)" />
          </div>
        </div>
        <div style="margin: auto; width: 100%">
          <div class="display margin-l-l title-font">
            <div class="cursor" (click)="navigate()">Our Network</div>
            <div class="margin-l"><app-skelton></app-skelton></div>
          </div>

          <div class="display margin-l-l title-font">
            <div>Visitors</div>
            <div class="margin-l"><app-skelton></app-skelton></div>
          </div>
        </div>
      </div>

      <div style="text-align: end" *ngIf="type != 'profile'">
        <app-skelton></app-skelton>
        <app-skelton></app-skelton>
      </div>
    </div>
  </div>

  <div *ngIf="!loading" class="card-body">
    <div class="display border-b" style="margin-bottom: 20px">
      <div><img src="assets/icon-1.jpg" style="height: 22px" /></div>
      <div class="margin-l border-b">
        <p class="margin-b title-font">
          <app-skelton></app-skelton>
        </p>
      </div>
    </div>

    <div class="display border-b" style="margin-bottom: 20px">
      <div><img src="assets/org.png" style="height: 20px" /></div>
      <div class="margin-l">
        <p class="margin-b title-font">
          <app-skelton></app-skelton>
        </p>
      </div>
    </div>
    <!-- <div class="display border-b" style="margin-bottom: 20px">
      <div><img src="assets/images/hands.png" style="height: 20px" /></div>
      <div class="margin-l">
        <p class="margin-b title-font">
          <app-skelton></app-skelton>
        </p>
      </div>
    </div> -->

    <div class="border-b margin-b">
      <h5 class="card-title font-weight">Introduction</h5>
      <p class="margin-b">
      {{props?.introduction}}
</p>
    </div>

    <div class="border-b margin-b">
      <h5 class="card-title font-weight">General Info</h5>
      <p class="margin-b">
        <app-skelton></app-skelton>
      </p>
    </div>

    <div class="border-b margin-b">
      <h5 class="card-title font-weight">Let's Pray</h5>
      <p class="margin-b">
        <app-skelton></app-skelton>
      </p>
    </div>

    <div class="border-b margin-b">
      <div class="margin-b display">
        <div><i class="fas fa-map-marker-alt font-size"></i></div>
        <div class="margin-l-l">
          <p class="margin-b address-text">
            <app-skelton></app-skelton>
          </p>
        </div>
      </div>

      <div class="margin-b display">
        <div><i class="fa-thin fa-phone-waveform font-size"></i></div>
        <div class="margin-l-l">
          <p class="margin-b address-text">
            <app-skelton></app-skelton>
          </p>
        </div>
      </div>

      <div class="margin-b display">
        <div><i class="fas fa-phone font-size"></i></div>
        <div class="margin-l-l">
          <p class="margin-b address-text">
            <app-skelton></app-skelton>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
